import { use } from 'react';

import { AuthContext } from '@/app/contexts/AuthContext';

export const useAuth = () => {
  const context = use(AuthContext);

  if (!context) {
    throw new Error('useAuth must be in AuthProvider');
  }

  return context;
};
